import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex p-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "w-fit flex gap-x-3 grid-cols-3 items-center"
}

import RezTabFile from '@/store/modules/RezTabFile';
import { StaffLine } from '@/store/modules/Staff';
import { TabCourseTuningInfo } from '@/store/modules/types';
import { XMarkIcon } from '@heroicons/vue/24/solid';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffLineTuning',
  props: {
    tuning: {},
    staffLineN: {},
    staffIndex: {}
  },
  emits: ['removeStaffLine'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const store = useStore();
const emits = __emit


return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.tuning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " NO TUNING " + _toDisplayString({staffLineN: __props.staffLineN}), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_va_input, {
            color: "white",
            label: "course",
            class: "w-12 text-center",
            type: "text",
            modelValue: __props.tuning.n,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.tuning.n) = $event)),
            disabled: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_va_input, {
            color: "white",
            label: "pname",
            class: "w-12 text-center",
            type: "text",
            modelValue: __props.tuning.pname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.tuning.pname) = $event)),
            placeholder: "pname"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_va_input, {
            color: "white",
            label: "oct",
            class: "w-12 text-center",
            type: "text",
            modelValue: __props.tuning.oct,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.tuning.oct) = $event)),
            placeholder: "oct"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "flex items-center fill-red-400 text-red-900 opacity-50 cursor-pointer hover:opacity-60",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('removeStaffLine', __props.staffIndex, __props.staffLineN)))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "w-8 self-center" })
          ])
        ]))
  ]))
}
}

})